export const LLM_CONFIG = {
    google: {
      models: {
        'Gemini 2.0 Flash': 'gemini-2.0-flash',
        'Gemini 2.0 Flash Lite Preview': 'gemini-2.0-flash-lite-preview-02-05',
        'Gemini 2.0 Flash Multimodal Live API (Experimental)': 'gemini-2.0-flash-realtime-exp',
        'Gemini 2.0 Flash Thinking (Experimental)': 'gemini-2.0-flash-thinking-exp',
        'Gemini 1.5 Flash': 'gemini-1.5-flash',
        'Gemini 1.5 Pro': 'gemini-1.5-pro',
        'Gemini 2.5 Pro Preview (05-06)': 'gemini-2.5-pro-preview-05-06',
        'Gemini 2.5 Flash Preview (05-20)': 'gemini-2.5-flash-preview-05-20',
        'Gemini 2.5 Flash Preview (04-17)': 'gemini-2.5-flash-preview-04-17',
        'Gemini 2.0 Pro Experimental (02-05)': 'gemini-2.0-pro-exp-02-05',
        'Gemini 2.0 Flash Experimental': 'gemini-2.0-flash-exp',
        'Gemini 2.0 Flash Lite': 'gemini-2.0-flash-lite',
        'Gemini 1.5 Flash (002)': 'gemini-1.5-flash-002',
        'Gemini 1.5 Pro (002)': 'gemini-1.5-pro-002',
        'Gemini 1.0 Pro': 'gemini-1.0-pro'
      }
    },
    openai: {
      models: {
         'GPT-5' :'gpt-5',
       'GPT-5 mini': 'gpt-5-mini',
       'GPT-5 nano': 'gpt-5-nano',
       'GPT-4o': 'gpt-4o',
       'GPT-4 Turbo': 'gpt-4-turbo',
       'GPT-4': 'gpt-4',
       'GPT-3.5 Turbo': 'gpt-3.5-turbo',
       'GPT-4 Turbo Preview': 'gpt-4-turbo-preview',
       'GPT-4o Mini': 'gpt-4o-mini',
       'GPT-4o Realtime': 'gpt-4o-realtime-preview-2024-12-17',
       'GPT-4o Mini Realtime': 'gpt-4o-mini-realtime-preview-2024-12-17',
       'GPT-4o (May 13)': 'gpt-4o-2024-05-13',
       'GPT-4o (Aug 6)': 'gpt-4o-2024-08-06',
       'GPT-4o (Nov 20)': 'gpt-4o-2024-11-20',
       'GPT-4.5 Preview': 'gpt-4.5-preview',
       'GPT-4.1': 'gpt-4.1',
       'GPT-4.1 Mini': 'gpt-4.1-mini',
       'GPT-4.1 Nano': 'gpt-4.1-nano',
       'GPT-4.1 (Apr 14)': 'gpt-4.1-2025-04-14',
       'GPT-4.1 Mini (Apr 14)': 'gpt-4.1-mini-2025-04-14',
       'GPT-4.1 Nano (Apr 14)': 'gpt-4.1-nano-2025-04-14',
       'GPT-4-0125 Preview': 'gpt-4-0125-preview',
       'GPT-4-1106 Preview': 'gpt-4-1106-preview',
       'GPT-4-0613': 'gpt-4-0613',
       'GPT-3.5 Turbo (16K)': 'gpt-3.5-turbo-16k',
       'GPT-3.5 Turbo (0125)': 'gpt-3.5-turbo-0125',
       'GPT-3.5 Turbo (1106)': 'gpt-3.5-turbo-1106',
       'GPT-3.5 Turbo (0613)': 'gpt-3.5-turbo-0613',
      }
     }
  };